type ProblemSolutions = {
    // problem: string;
    solutions: string[]
}

export const problemSolutions: Map<string, ProblemSolutions> = new Map()

problemSolutions.set('INFILTRAÇÕES EM PAREDES E MUROS EXTERNOS', {
    solutions: ['TRATAMENTO DE TRINCAS', 'PINTURA EMBORRACHADA']
})
problemSolutions.set('TRATAMENTO CONTRA UMIDADE DE PÉ DE PAREDE OU MOFO DE RODAPÉ', {
    solutions: ['CIMENTO POLIMÉRICO SOBRE OS TIJOLOS ( ANTES DO REBOCO)',
        'IMPERMEABILIZAÇÃO DO REBOCO',
        'FUNDO PREPARADOR IMPERMEÁVEL (SOBRE O REBOCO)',
        'MASSA CORRIDA IMPERMEÁVEL',
    ]
})
problemSolutions.set('TRATAMENTO CONTRA LAJES EXPOSTAS, TELHAS E  CALHAS VAZANDO', {
    solutions: []
})
problemSolutions.set('RESERVATÓRIOS DE CONCRETO VAZANDO', {
    solutions: []
})
problemSolutions.set('LAJES DE COBERTURA, PLAYGROUDS, GARAGENS COM CORROSÃO E INFILTRAÇÕES', {
    solutions: []
})
problemSolutions.set('REDUÇÃO DO CALOR E IMPERMEABILIZAÇÃO DE DE TELHAS METÁLICAS E FIBRO CIMENTOS', {
    solutions: []
})
problemSolutions.set('VEDAÇÃO EM TELHAS, RUFOS, CALHAS', {
    solutions: []
})
problemSolutions.set('SELAMENTO DE JUNTAS DE PISOS E FACHADAS', {
    solutions: []
})
problemSolutions.set('COLAGEM FLEXÍVEL DE RUFOS, CALHAS, ESPELHOS, CUBAS, PIAS, VASOS SANITÁRIOS', {
    solutions: []
})
problemSolutions.set('COLAGENS ESTRUTURAIS DE CONCRETO COM CONCRETO, FERRO E FIXADORES EM CONCRETO', {
    solutions: []
})
problemSolutions.set('REFORÇO E RECUPERAÇÃO ESTRUTURAL EM CONCRETO DE PISOS, PILARES, VIGAS E LAJES', {
    solutions: []
})



